import { render, staticRenderFns } from "./order_invoice.vue?vue&type=template&id=1a34a8d6&scoped=true&"
import script from "./order_invoice.vue?vue&type=script&lang=js&"
export * from "./order_invoice.vue?vue&type=script&lang=js&"
import style0 from "./order_invoice.vue?vue&type=style&index=0&id=1a34a8d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a34a8d6",
  null
  
)

export default component.exports